export const KEYS = {
    CODE: 'code',
    LANGUAGE_CODE: 'languageCode',
    PATHNAME_AFTER_AUTH: 'pathnameAfterAuth'
};



// WEBPACK FOOTER //
// ./src/constants/LocalStorage.js